/*! Echelon — LinkedByte */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const on = (el, ev, fn) => el && el.addEventListener(ev, fn);

  /* ---------- Drawer system ---------- */
  const overlay = (() => {
    const el = document.createElement('div');
    el.className = 'overlay';
    document.body.appendChild(el);
    return el;
  })();
  const openDrawer = (sel) => {
    const d = $(sel);
    if (!d) return;
    d.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  const closeDrawers = () => {
    $$('.drawer.is-open').forEach((d) => d.classList.remove('is-open'));
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };
  on(overlay, 'click', closeDrawers);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });
  $$('[data-drawer-open]').forEach((b) => on(b, 'click', () => openDrawer(b.dataset.drawerOpen)));
  $$('[data-drawer-close]').forEach((b) => on(b, 'click', closeDrawers));

  /* ---------- Sticky header on scroll-up ---------- */
  let lastY = 0;
  const header = $('.header');
  if (header) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > 200 && y > lastY) header.style.transform = 'translateY(-100%)';
      else header.style.transform = '';
      lastY = y;
    }, { passive: true });
  }

  /* ---------- Cart fetching ---------- */
  async function getCart() {
    const r = await fetch(`${window.routes.cart_url}.js`);
    return r.json();
  }
  async function addToCart(id, qty = 1, props = {}) {
    const r = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id, quantity: qty, properties: props }] })
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      throw new Error(err.description || window.cartStrings.error);
    }
    return r.json();
  }
  async function changeCart(line, qty) {
    const r = await fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ line, quantity: qty })
    });
    return r.json();
  }
  function formatMoney(cents) {
    const fmt = window.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, (cents / 100).toFixed(2));
  }
  async function refreshCartUI() {
    const cart = await getCart();
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count ? '' : 'none';
    });
    const drawerBody = $('#cart-drawer .drawer__body');
    const drawerFoot = $('#cart-drawer .drawer__foot');
    if (drawerBody && drawerFoot) {
      if (!cart.item_count) {
        drawerBody.innerHTML = `<p class="text-center" style="padding:3rem 0;color:var(--color-muted)">Your cart is empty.</p>`;
        drawerFoot.innerHTML = '';
      } else {
        drawerBody.innerHTML = cart.items.map((it, i) => `
          <div class="cart-row" style="grid-template-columns:64px 1fr auto;gap:.75rem">
            <div class="cart-row__media"><img src="${it.image ? it.image + '&width=120' : ''}" alt=""></div>
            <div class="cart-row__info">
              <h4>${it.product_title}</h4>
              <p>${it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title + ' · ' : ''}${formatMoney(it.final_line_price)}</p>
              <div class="qty mt-1">
                <button data-line="${i + 1}" data-qty="${it.quantity - 1}" aria-label="Decrease">−</button>
                <input value="${it.quantity}" readonly>
                <button data-line="${i + 1}" data-qty="${it.quantity + 1}" aria-label="Increase">+</button>
              </div>
            </div>
            <button data-line="${i + 1}" data-qty="0" aria-label="Remove">✕</button>
          </div>
        `).join('');
        drawerFoot.innerHTML = `
          <div class="cart-summary__row cart-summary__total"><span>Total</span><span>${formatMoney(cart.total_price)}</span></div>
          <a href="/checkout" class="btn btn--accent" style="width:100%;margin-top:1rem">Checkout</a>
          <a href="/cart" class="btn btn--outline" style="width:100%;margin-top:.5rem">View cart</a>
        `;
      }
      $$('#cart-drawer button[data-line]').forEach((b) => on(b, 'click', async () => {
        await changeCart(parseInt(b.dataset.line, 10), parseInt(b.dataset.qty, 10));
        refreshCartUI();
      }));
    }
  }
  refreshCartUI();

  /* ---------- Add-to-cart forms ---------- */
  $$('form.product-form-ajax').forEach((form) => {
    on(form, 'submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type=submit]');
      const id = form.querySelector('[name=id]').value;
      const qtyInput = form.querySelector('[name=quantity]');
      const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (btn) btn.disabled = true;
      try {
        await addToCart(id, qty);
        await refreshCartUI();
        if ((window.cartType || 'drawer') === 'drawer') openDrawer('#cart-drawer');
      } catch (err) {
        alert(err.message);
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  });

  /* ---------- Variant picker ---------- */
  class VariantPicker {
    constructor(root) {
      this.root = root;
      this.product = JSON.parse(root.querySelector('[data-product-json]').textContent);
      this.form = root.closest('form') || $(`#product-form-${root.dataset.section}`);
      this.priceEl = root.querySelector('[data-price]');
      this.priceCompareEl = root.querySelector('[data-price-compare]');
      this.idInput = this.form && this.form.querySelector('[name=id]');
      this.btn = this.form && this.form.querySelector('[type=submit]');
      $$('[data-option-input]', root).forEach((el) => on(el, 'change', () => this.update()));
      $$('[role=radio]', root).forEach((el) => on(el, 'click', () => this.selectRadio(el)));
      this.update();
    }
    selectRadio(el) {
      const group = el.closest('[role=radiogroup]');
      $$('[role=radio]', group).forEach((r) => r.setAttribute('aria-checked', 'false'));
      el.setAttribute('aria-checked', 'true');
      const input = group.querySelector('input[data-option-input]');
      if (input) { input.value = el.dataset.value; input.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    selected() {
      const opts = $$('input[data-option-input]', this.root).map((i) => i.value);
      return this.product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    }
    update() {
      const v = this.selected();
      if (!v) {
        if (this.btn) { this.btn.disabled = true; this.btn.textContent = window.variantStrings.unavailable; }
        return;
      }
      if (this.idInput) this.idInput.value = v.id;
      if (this.priceEl) this.priceEl.textContent = formatMoney(v.price);
      if (this.priceCompareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          this.priceCompareEl.textContent = formatMoney(v.compare_at_price);
          this.priceCompareEl.style.display = '';
        } else {
          this.priceCompareEl.style.display = 'none';
        }
      }
      if (this.btn) {
        this.btn.disabled = !v.available;
        this.btn.textContent = v.available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
      }
      const main = $('[data-product-main-image]');
      if (v.featured_image && main) {
        main.querySelector('img').src = v.featured_image.src + '&width=900';
      }
      const url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }
  }
  $$('[data-variant-picker]').forEach((el) => new VariantPicker(el));

  /* ---------- Product gallery thumbs ---------- */
  $$('[data-product-gallery]').forEach((g) => {
    const main = g.querySelector('[data-product-main-image] img');
    const thumbs = $$('[data-thumb]', g);
    thumbs.forEach((t) => on(t, 'click', () => {
      thumbs.forEach((x) => x.classList.remove('is-active'));
      t.classList.add('is-active');
      if (main) main.src = t.dataset.src;
    }));
  });

  /* ---------- Quantity controls ---------- */
  $$('[data-qty-control]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((b) => on(b, 'click', () => {
      const dir = b.dataset.dir === '+' ? 1 : -1;
      input.value = Math.max(1, parseInt(input.value, 10) + dir);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });

  /* ---------- Predictive search ---------- */
  const searchInput = $('[data-predictive-search-input]');
  const searchResults = $('[data-predictive-search-results]');
  if (searchInput && searchResults) {
    let t;
    on(searchInput, 'input', () => {
      clearTimeout(t);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; searchResults.hidden = true; return; }
      t = setTimeout(async () => {
        const r = await fetch(`${window.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`);
        const html = await r.text();
        const wrap = document.createElement('div');
        wrap.innerHTML = html;
        searchResults.innerHTML = wrap.querySelector('[data-predictive-search-results-inner]')?.innerHTML || '';
        searchResults.hidden = false;
      }, 200);
    });
  }

  /* ---------- Marquee duplication for seamless loop ---------- */
  $$('.announcement-marquee__track').forEach((t) => {
    if (t.children.length < 2) t.innerHTML += t.innerHTML;
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    $$('[data-animate]').forEach((el) => io.observe(el));
  }
})();
